import { render, staticRenderFns } from "./TranslationsCompletion.vue?vue&type=template&id=7cc1193a&scoped=true&"
import script from "./TranslationsCompletion.vue?vue&type=script&lang=ts&"
export * from "./TranslationsCompletion.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsCompletion.vue?vue&type=style&index=0&id=7cc1193a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc1193a",
  null
  
)

export default component.exports